import { Directive, ElementRef, AfterContentInit } from '@angular/core';

@Directive({
	selector: '[copoFocusMe]',
})
export class FocusMeDirective implements AfterContentInit {
	constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

	ngAfterContentInit() {
		if (document.activeElement !== this.elementRef.nativeElement) {
			// changing focus can trigger changes in other components
			// requesting an animation frame to delay the focus
			requestAnimationFrame(() => {
				this.elementRef.nativeElement.focus();
			});
		}
	}
}
